/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, UsersAuthzCheckUserPermissionUserPermissionsPathParams, UsersAuthzCheckUserPermissionUserPermissions401, UsersAuthzCheckUserPermissionUserPermissions403 } from "../models/UsersAuthzCheckUserPermissionUserPermissions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzCheckUserPermissionUserPermissions } from "../axios/usersAuthzCheckUserPermissionUserPermissions";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzCheckUserPermissionUserPermissionsQueryKey = (permission: UsersAuthzCheckUserPermissionUserPermissionsPathParams["permission"]) => ["api-v2", { url: '/users-authz/v1/user/permissions/:permission', params: {permission:permission} }] as const

export type UsersAuthzCheckUserPermissionUserPermissionsQueryKey = ReturnType<typeof usersAuthzCheckUserPermissionUserPermissionsQueryKey>

export function usersAuthzCheckUserPermissionUserPermissionsQueryOptions(permission: UsersAuthzCheckUserPermissionUserPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = usersAuthzCheckUserPermissionUserPermissionsQueryKey(permission)
        return queryOptions<UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, ResponseErrorConfig<UsersAuthzCheckUserPermissionUserPermissions401 | UsersAuthzCheckUserPermissionUserPermissions403>, UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, typeof queryKey>({
         enabled: !!(permission),
         queryKey,
         queryFn: async ({ signal }) => {
            return usersAuthzCheckUserPermissionUserPermissions(permission, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Check if the current user has a specific permission
 * {@link /users-authz/v1/user/permissions/:permission}
 */
export function useUsersAuthzCheckUserPermissionUserPermissions<TData = UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, TQueryData = UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, TQueryKey extends QueryKey = UsersAuthzCheckUserPermissionUserPermissionsQueryKey>(permission: UsersAuthzCheckUserPermissionUserPermissionsPathParams["permission"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, ResponseErrorConfig<UsersAuthzCheckUserPermissionUserPermissions401 | UsersAuthzCheckUserPermissionUserPermissions403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? usersAuthzCheckUserPermissionUserPermissionsQueryKey(permission)
         

         const query = useQuery({
          ...usersAuthzCheckUserPermissionUserPermissionsQueryOptions(permission, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UsersAuthzCheckUserPermissionUserPermissions401 | UsersAuthzCheckUserPermissionUserPermissions403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}